import React from 'react';

interface ITwoLineCellProps {
    primary: string;
    secondary?: string;
}

export function TwoLineCell({ primary, secondary }: ITwoLineCellProps) {
    if (!primary && !secondary) {
        return null;
    }

    const title = [primary, secondary].filter(Boolean).join('\n');

    return (
        <div className="d-flex flex-column" style={{ minWidth: 0 }} title={title}>
            {primary ? <span className="d-block text-truncate">{primary}</span> : null}
            {secondary ? <span className="d-block text-truncate text-muted">{secondary}</span> : null}
        </div>
    );
}
